import { TId } from 'src/shared/contract/id'
import { webApiBuildUrl } from '@api/utils'
import { ErrorResponse, fetchApi } from 'src/shared/lib/response-worker/model'
import { CatalogGoodBase, FullCatalog, ICatalogGoodBase, IFullCatalog } from '@entities/goods/contract'
import { IBaseCatalogQuery } from 'src/shared/contract/type'
import { Array } from 'runtypes'

export interface IRequestGoodGroup extends IBaseCatalogQuery {
    groupId: TId
}

export interface IRequestGoodSearch extends IBaseCatalogQuery {
    term: string
}

function goodGroupUrl({ groupId }: { groupId: number }): string {
    return webApiBuildUrl(`api/catalog/groups/${groupId}`)
}

function goodSearchUrl(term: string): string {
    return webApiBuildUrl(`api/catalog/goods/search/?q=${term}`)
}

export async function getGoodGroupById({ groupId, shipment, ctx }: IRequestGoodGroup): Promise<IFullCatalog> {
    const response = await fetchApi.post<IFullCatalog>(goodGroupUrl({ groupId }), shipment, ctx)
    const validated = FullCatalog.validate(response.data)
    if (!validated.success) console.error({ validated })
    if (!(response.data as ErrorResponse).IsError) return response.data as IFullCatalog
    else throw new Error(JSON.stringify(response.data))
}

export async function searchGoods({ term, shipment, ctx }: IRequestGoodSearch): Promise<ICatalogGoodBase[]> {
    const response = await fetchApi.post<ICatalogGoodBase[]>(goodSearchUrl(term), shipment, ctx)
    const validated = Array(CatalogGoodBase).validate(response.data)
    if (!validated.success) console.error({ validated })
    if (!(response.data as ErrorResponse).IsError) return response.data as ICatalogGoodBase[]
    else throw new Error(JSON.stringify(response.data))
}
